export function LocationIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width='19' height='21' viewBox='0 0 19 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M15.0572 14.6569C14.1206 15.5935 12.162 17.5521 10.8142 18.8999C10.0331 19.681 8.76807 19.6814 7.98702 18.9003C6.66273 17.576 4.74198 15.6553 3.74354 14.6569C0.619342 11.5327 0.619342 6.46734 3.74354 3.34315C6.86773 0.218951 11.933 0.218951 15.0572 3.34315C18.1814 6.46734 18.1814 11.5327 15.0572 14.6569Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.4004 9C12.4004 10.6569 11.0572 12 9.40039 12C7.74354 12 6.40039 10.6569 6.40039 9C6.40039 7.34315 7.74354 6 9.40039 6C11.0572 6 12.4004 7.34315 12.4004 9Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
